import api from "../api"

type CheckClientVersionResponse = {
  showOldVersionWarning: boolean
  forceUpdate: boolean
  isPatchUpdate: boolean
  lastCheckedAt: string
}

export const checkClientVersion = async (): Promise<CheckClientVersionResponse> => {
  return (await api.get('/check-client-version')).data
}